interface IconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export function ArrowUpIcon({ size = 24, color, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      style={color ? { color } : undefined}
      className={className}
      aria-hidden="true"
    >
      <path d="M8.54375 1.23125C8.4 1.08438 8.20625 1 8 1C7.79375 1 7.6 1.08438 7.45625 1.23125L2.20625 6.73125C1.91875 7.03125 1.93125 7.50625 2.23125 7.79063C2.53125 8.075 3.00625 8.06563 3.29063 7.76562L7.25 3.62188V14.25C7.25 14.6656 7.58438 15 8 15C8.41563 15 8.75 14.6656 8.75 14.25V3.62188L12.7063 7.76875C12.9938 8.06875 13.4656 8.07812 13.7656 7.79375C14.0656 7.50937 14.075 7.03438 13.7906 6.73438L8.54063 1.23438L8.54375 1.23125Z" />
    </svg>
  );
}
